import { useAcquireControlLock, useControlLock } from '@ctcells/api'
import { errorMessage, t } from '@ctcells/i18n'

import { ControlLockChip } from '../../shell/ControlLockChip.tsx'
import { toControlLockView } from '../../shell/batchStripModel.ts'
import { gate, type ScreenAccess } from '../access.ts'

/** 상단과 같은 획득 훅·리스 보관소를 쓴다. 성공 후에도 작업 추가 폼은 유지한다. */
export function BatchNewLockControl({ access }: { access: ScreenAccess }) {
  const lock = useControlLock()
  const acquire = useAcquireControlLock()
  const accessGate = gate(access, { perm: 'control' })
  const disabledReason = accessGate.disabled
    ? accessGate.disabledReason
    : acquire.isPending
      ? t('reason.actionInFlight')
      : undefined

  return (
    <>
      {acquire.error !== null ? (
        <p className="vissue addfoot__error" role="alert">
          {errorMessage(acquire.error)}
        </p>
      ) : null}
      <ControlLockChip
        lock={toControlLockView(lock)}
        {...(disabledReason === undefined ? {} : { disabledReason })}
        onAction={(action) => {
          if (action === 'acquire' && disabledReason === undefined) acquire.mutate({})
        }}
      />
    </>
  )
}
